import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Portal } from 'react-overlays';
import { connect } from 'react-redux';

import * as SearchActions from '~app/actions/search';
import { clearBiomeDetails } from '~app/actions/biomeDetails';
import { isFavoriteLocationInfo } from '~app/actions/favorites';

import BiomeInfoScreen from './BiomeInfoScreen';

class BiomeInfoModal extends Component {

  onChangeLeft() {
    const currentRight = this.props.locationInfos[1];
    this.switchToLocationInfo(currentRight);

    this.props.enterCompareMode(SearchActions.SelectionMode.compareLeft);
    this.props.clearBiomeDetails();
  }

  onChangeRight() {
    const currentLeft = this.props.locationInfos[0];
    this.switchToLocationInfo(currentLeft);

    this.props.enterCompareMode(SearchActions.SelectionMode.compareRight);
    this.props.clearBiomeDetails();
  }

  switchToLocationInfo(locationInfo) {
    if (locationInfo !== this.props.selectedLocationInfo) {
      // Make sure we keep the pin that is not changing.
      this.props.clearSelection();
      this.props.clearPins();

      // Only drop a new pin if the location we want to select here is not a
      // favorite. Otherwise, it already has a persistent favorite marker.
      if (!isFavoriteLocationInfo(locationInfo, this.props.favorites)) {
        this.props.dropPin(locationInfo.location);
      }

      this.props.selectLocation(locationInfo.location);
      this.props.selectLocationInfo(locationInfo);

      // Warp to the new location so it is centered when we remove the compare UI.
      this.props.centerLocation(locationInfo.location, { duration: 0.0 });
    }
  }

  onClose() {
    // Exit compare mode if we were in it.
    this.props.exitCompareMode();

    // Clear all pins and search locations.
    this.props.clearSelection();
    this.props.clearPins();
    this.props.clearSearchTerm();

    // Close the modal UI.
    this.props.clearBiomeDetails();
  }

  render() {
    return (
      (this.props.locationInfos.length > 0) &&
      <Portal>
        <BiomeInfoScreen
          locationInfos={this.props.locationInfos}
          isBusy={this.props.isBusy}
          onChangeLeft={this.props.locationInfos.length > 1 ?
            ::this.onChangeLeft : undefined}
          onChangeRight={this.props.locationInfos.length > 1 ?
            ::this.onChangeRight : undefined}
          onClose={::this.onClose}
        />
      </Portal>
    );
  }
}

BiomeInfoModal.propTypes = {
  isBusy: PropTypes.bool.isRequired,
  locationInfos: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  isBusy: state.busy.isBusy,
  selectedLocationInfo: state.search.selectedLocationInfo,
  locationInfos: state.biomeDetails.locationInfos,
  favorites: state.favorites.locationInfos,
});

const mapDispatchToProps = {
  clearBiomeDetails,
  clearPins: SearchActions.clearPins,
  clearSearchTerm: SearchActions.clearSearchTerm,
  clearSelection: SearchActions.clearSelection,
  dropPin: SearchActions.dropPin,
  enterCompareMode: SearchActions.enterCompareMode,
  exitCompareMode: SearchActions.exitCompareMode,
  centerLocation: SearchActions.centerLocation,
  selectLocation: SearchActions.selectLocation,
  selectLocationInfo: SearchActions.selectLocationInfo,
};

export { BiomeInfoModal };
export default connect(mapStateToProps, mapDispatchToProps)(BiomeInfoModal);



// WEBPACK FOOTER //
// ./src/components/BiomeInfoModal.js